<template>
  <div class="jurisd">
    <!-- 移除 required 和 rules，避免 label for 错误（内部 div 不是表单控件） -->
    <div class="jurisd-form-item width100" style="margin-bottom: 18px;">
      <label
        class="jurisd-label"
        style="width: 120px; text-align: right; padding-right: 12px; display: inline-block; vertical-align: top; line-height: 32px;"
        >{{ title }}</label
      >
      <div
        class="jurisd-content"
        style="display: inline-block; width: calc(100% - 132px);"
      >
        <div
          class="lab"
          :class="{ active: item.isActive }"
          v-for="(item, index) in form.authCustLevel || []"
          :key="index"
          @click="handleActive(item, 'authCustLevel')"
        >
          <i class="el-icon-success" v-if="item.isActive"></i>{{ item.value }}
        </div>
        <!-- <div class="lab" :class="{'active': item.isActive}" v-for="(item,index) in form.sysRoleList" :key="index" @click="handleActive(item)">
        <i class="el-icon-success" v-if="item.isActive"></i>{{item.value}}
      </div> -->
        <div
          class="lab"
          :class="{ active: item.isActive }"
          v-for="(item, index) in form.authTechLevel || []"
          :key="index"
          @click="handleActive(item, 'authTechLevel')"
        >
          <i class="el-icon-success" v-if="item.isActive"></i>{{ item.value }}
        </div>
        <div
          class="lab"
          :class="{ active: form.isAuthInsider }"
          @click="handleAuthsInternal()"
        >
          <i class="el-icon-success" v-if="form.isAuthInsider"></i>内部员工
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import customerLevelApi from "@/api/sys/customerLevel";
import technicalServiceLevelApi from "@/api/sys/technicalServiceLevel";
export default {
  props: ["form", "title"],
  data() {
    return {
      options: {
        customerLevel: [], //   业务线-客户级别
        // registerRole: [],   //职能线-用户角色
        technicalServiceLevel: [] //技术线-技术线级别
      },
      loading: false // 防止重复请求
    };
  },
  created() {
    // 组件创建时总是初始化，确保数据正确加载
    // v-if 会销毁重建组件，所以每次创建都会执行
    this.initOptions();
  },
  methods: {
    /** 列表接口可能直接返回数组，也可能返回 { list, total } */
    normalizeListPayload(data) {
      if (Array.isArray(data)) return data;
      if (data && Array.isArray(data.list)) return data.list;
      return [];
    },
    getLevelIdsBySources(data, sources) {
      // 确保sources是一个数组，如果传入的是单个值则转为数组
      const sourceList = Array.isArray(sources) ? sources : [sources];

      // 筛选出符合条件的项并返回levelId数组
      const result = [];
      data
        .filter(item => sourceList.includes(item.levelSource))
        .forEach(item => {
          // 支持两种格式：
          // 1. { levelSource: 1, levelId: 1 } - 单个 levelId
          // 2. { levelSource: 1, levelIds: "1,2,3" } - levelIds 字符串（用逗号分隔）
          if (item.levelId !== undefined && item.levelId !== null) {
            // 如果是单个 levelId，直接添加
            result.push(item.levelId);
          } else if (item.levelIds !== undefined && item.levelIds !== null) {
            // 如果是 levelIds 字符串，需要解析
            const ids = String(item.levelIds).split(',').map(id => id.trim()).filter(id => id);
            result.push(...ids);
          }
        });
      return result;
    },
    async initOptions() {
      // 防止重复请求（同一组件实例）
      if (this.loading) {
        return;
      }

      // 每次组件创建都重新加载数据，确保数据是最新的
      // 注意：v-if 会销毁重建组件，每次创建都是新的组件实例，所以每次都会执行
      this.loading = true;

      try {
        let { levelDataList, levelData } = this.form;

        // 如果 levelDataList 不存在或不是数组，尝试从 levelData 字符串解析
        if (!levelDataList || !Array.isArray(levelDataList)) {
          if (levelData && typeof levelData === 'string' && levelData.trim()) {
            try {
              levelDataList = JSON.parse(levelData);
              // 确保解析后是数组
              if (!Array.isArray(levelDataList)) {
                levelDataList = [];
              }
            } catch (e) {
              console.warn('解析 levelData 失败:', e);
              levelDataList = [];
            }
          } else {
            levelDataList = [];
          }
        }

        // 获取客户级别
        let custLevels = [];
        try {
          const response = await customerLevelApi.fetchList({
            levelSortSign: -1
          });
          custLevels = this.normalizeListPayload(response.data);
        } catch (error) {
          console.error('获取客户级别失败:', error);
          custLevels = [];
        }
        
        // 取后端传入的已选id字符串，转换为数组
        const selectedCust =
          levelDataList.length > 0
            ? this.getLevelIdsBySources(levelDataList, 1).map(id => String(id))
            : [];
        let custArr = (custLevels || []).map(item => ({
          value: item.name,
          key: item.id,
          isActive: selectedCust.includes(String(item.id))
        }));

        // 使用 $set 确保响应式更新，无论字段是否存在
        this.$set(this.form, "authCustLevel", custArr);

        // 获取技术线级别（fetchList 分页接口返回 { list, total }，与直接数组两种形态都兼容）
        let techLevels = [];
        try {
          const response = await technicalServiceLevelApi.fetchList();
          techLevels = this.normalizeListPayload(response.data);
        } catch (error) {
          console.error('获取技术线级别失败:', error);
          techLevels = [];
        }
        // 取后端传入的已选id字符串，转换为数组
        const selectedTech =
          levelDataList.length > 0
            ? this.getLevelIdsBySources(levelDataList, 2).map(id => String(id))
            : [];
        let techArr = (techLevels || []).map(item => ({
          value: item.name,
          key: item.id,
          isActive: selectedTech.includes(String(item.id))
        }));
        // 使用 $set 确保响应式更新，无论字段是否存在
        this.$set(this.form, "authTechLevel", techArr);

        // 初始化内部员工选项
        // 始终根据 levelDataList 来设置，确保每次进入都正确显示
        let find = levelDataList.find(item => item.levelSource === 3);
        this.$set(this.form, "isAuthInsider", !!find);

        // 强制更新视图，确保数据渲染
        this.$nextTick(() => {
          this.$forceUpdate();
        });
      } catch (error) {
        console.error('权限身份选项初始化失败:', error);
      } finally {
        this.loading = false;
      }
    },
    handleAuthsInternal() {
      this.form.isAuthInsider = !this.form.isAuthInsider;
      this.clacFuc();
      this.$forceUpdate();
    },
    handleActive(item, type) {
      // 多选逻辑
      item.isActive = !item.isActive;
      this.clacFuc(item.key, type);
      this.$forceUpdate();
    },
    clacFuc(code, type) {
      // 组装选中的id数组
      const getSelectedIds = arr => arr.filter(i => i.isActive).map(i => i.key);
      const result = {
        ...this.form,
        authCustLevel: getSelectedIds(this.form.authCustLevel || []),
        authTechLevel: getSelectedIds(this.form.authTechLevel || []),
        isAuthInsider: this.form.isAuthInsider || false
      };
      this.$emit("change", result);
    }
  }
};
</script>
<style lang="scss" scoped>
.jurisd {
  .jurisd-form-item {
    width: 100%;
    margin-bottom: 18px;

    .jurisd-label {
      width: 120px;
      text-align: right;
      padding-right: 12px;
      display: inline-block;
      vertical-align: top;
      line-height: 32px;
      font-size: 14px;
      color: #606266;
      box-sizing: border-box;

      &::before {
        content: "*";
        color: #f56c6c;
        margin-right: 4px;
      }
    }

    .jurisd-content {
      display: inline-block;
      width: calc(100% - 132px);
      vertical-align: top;
    }
  }

  .lab {
    font-size: 14px;
    color: #8f8e8e;
    border-radius: 4px;
    padding: 0 18px;
    display: inline-flex;
    align-items: center;
    border: 1px solid #c5c5c5;
    margin: 5px;
    position: relative;
    cursor: pointer;
    height: 32px;
    box-sizing: border-box;

    &.active {
      background: #5dbde7;
      color: #fff;
      border-color: #5dbde7;
    }

    i {
      position: absolute;
      left: 0;
      top: 0;
    }
  }
}
</style>
